var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 30,
    viewBox: "0 0 46 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4001 3.79907C34.8005 6.35326 37 10.4198 37 15C37 22.732 30.732 29 23 29C22.2382 29 21.4906 28.9392 20.7618 28.822C19.539 28.6256 18.369 28.2707 17.2736 27.7791C12.3967 25.5904 9 20.6919 9 15C9 10.4198 11.1995 6.35326 14.5999 3.79907C16.5471 2.33654 18.888 1.36986 21.4349 1.08652C21.9487 1.02935 22.4709 1 23 1C23.4232 1 23.8421 1.01879 24.2558 1.05557C26.9224 1.29266 29.3743 2.27753 31.4001 3.79907ZM8.53923 19C8.18777 17.7266 8 16.3852 8 15C8 14.3219 8.045 13.6543 8.13217 13H4V19H8.53923ZM37.1465 20C35.0873 25.826 29.5311 30 23 30C16.4689 30 10.9127 25.826 8.85352 20H4V21H3H1H0V20V12V11H1H3H4V12H8.30005C9.68988 5.15329 15.7431 0 23 0C30.2569 0 36.3101 5.15329 37.7 12H42V11H43H45H46V12V20V21H45H43H42V20H37.1465ZM37.8678 13H42V19H37.4608C37.8122 17.7266 38 16.3852 38 15C38 14.3219 37.955 13.6543 37.8678 13ZM3 19V20H1V12H3V13V19ZM43 13V12H45V20H43V19V13ZM23 27C29.6274 27 35 21.6274 35 15C35 8.37258 29.6274 3 23 3C16.3726 3 11 8.37258 11 15C11 21.6274 16.3726 27 23 27ZM23 28C30.1797 28 36 22.1797 36 15C36 7.8203 30.1797 2 23 2C15.8203 2 10 7.8203 10 15C10 22.1797 15.8203 28 23 28ZM15 12H31V17H15V12ZM14 11H15H31H32V12V17V18H31H15H14V17V12V11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.c626727e1a55140b6edb9f8df23def2b.svg";
export { ForwardRef as ReactComponent };